export default "__VITE_ASSET__BNNzivD___"